import React, { useEffect, useState } from "react";
import api from "../../api";
import { History, X } from "lucide-react";
import { fmtNum, fmtSigned, fmtDateTime } from "./balanceFields";

const AuditRow = ({ l }) => (
  <tr className="border-t border-gray-100 align-top" data-testid={`balance-audit-row-${l.id}`}>
    <td className="px-4 py-2.5 whitespace-nowrap text-gray-500 tabular-nums">{fmtDateTime(l.created_at)}</td>
    <td className="px-3 py-2.5"><div className="font-bold text-[#16345c]">{l.employee_name}</div><div className="text-[11px] text-gray-400">{l.matricola}</div></td>
    <td className="px-3 py-2.5 whitespace-nowrap">{l.field_label}{l.year ? ` ${l.year}` : ""}</td>
    <td className="px-3 py-2.5 whitespace-nowrap tabular-nums">
      <span className="text-gray-400">{fmtNum(l.before)}</span> → <b className="text-[#16345c]">{fmtNum(l.after)}</b> <span className="text-gray-400">{l.unit}</span>
      <span className={`ml-2 text-[11px] font-bold ${l.delta >= 0 ? "text-green-700" : "text-red-700"}`}>{fmtSigned(l.delta)}</span>
    </td>
    <td className="px-3 py-2.5 text-gray-700 min-w-[200px]" data-testid={`balance-audit-reason-${l.id}`}>{l.reason}</td>
    <td className="px-3 py-2.5 whitespace-nowrap text-gray-600">{l.actor_name}</td>
  </tr>
);

export const BalanceAuditLog = ({ refreshKey, employee, onClearEmployee }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const q = employee ? `?employee_id=${employee.id}` : "";
    api.get(`/balances/audit${q}`).then((r) => setLogs(r.data)).catch(() => setLogs([])).finally(() => setLoading(false));
  }, [refreshKey, employee]);

  return (
    <div id="balance-audit" className="mt-8 bg-white border border-gray-200 rounded-lg overflow-hidden" data-testid="balance-audit">
      <div className="flex items-center gap-2 flex-wrap px-4 py-3 border-b border-gray-100">
        <History size={16} className="text-[#16345c]" />
        <h3 className="text-[14px] font-black text-[#16345c] uppercase tracking-tight flex-1">Registro modifiche saldi</h3>
        {employee && (
          <button onClick={onClearEmployee} data-testid="balance-audit-clear-filter" className="flex items-center gap-1 text-[12px] font-bold text-[#16345c] bg-[#16345c]/10 hover:bg-[#16345c]/20 rounded-full px-3 py-1 transition-colors">
            {employee.name} <X size={13} />
          </button>
        )}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[820px] text-[12.5px]">
          <thead className="bg-gray-50 text-gray-500 text-[11px] uppercase">
            <tr><th className="text-left px-4 py-2">Data e ora</th><th className="text-left px-3 py-2">Dipendente</th><th className="text-left px-3 py-2">Contatore</th><th className="text-left px-3 py-2">Prima → Dopo</th><th className="text-left px-3 py-2">Motivo</th><th className="text-left px-3 py-2">Modificato da</th></tr>
          </thead>
          <tbody>{logs.map((l) => <AuditRow key={l.id} l={l} />)}</tbody>
        </table>
        {!loading && logs.length === 0 && <div className="px-4 py-8 text-center text-[13px] text-gray-400" data-testid="balance-audit-empty">Nessuna modifica registrata</div>}
      </div>
    </div>
  );
};
